var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04504 5.72407C7.1604 5.81784 7.2534 5.93614 7.31728 6.07038C7.38116 6.20462 7.41431 6.35141 7.41431 6.50007C7.41431 6.64873 7.38116 6.79552 7.31728 6.92976C7.2534 7.064 7.1604 7.18231 7.04504 7.27607L1.63104 11.6761C1.48436 11.7954 1.30686 11.8707 1.11913 11.8932C0.931406 11.9157 0.741141 11.8845 0.570407 11.8033C0.399673 11.7221 0.255466 11.5941 0.154513 11.4342C0.0535607 11.2744 -1.43051e-06 11.0891 3.95775e-05 10.9001L3.95775e-05 2.10007C-1.43051e-06 1.911 0.0535607 1.72579 0.154513 1.56592C0.255466 1.40605 0.399673 1.27808 0.570407 1.19685C0.741141 1.11562 0.931406 1.08445 1.11913 1.10697C1.30686 1.12949 1.48436 1.20477 1.63104 1.32407L7.04504 5.72407Z",
    fill: "#155BF1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.bb054611e66972442470c68bedc2b981.svg";
export { ForwardRef as ReactComponent };